<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      apiToken: '',
      storeName: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    apiToken: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const wbChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.storeName || 'Wildberries',
            channel: {
              type: 'wb',
              api_token: this.apiToken,
              store_name: this.storeName,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: wbChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.AUTH.CHANNEL.WB.FORM.CREATE_ERROR')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.WB.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.WB.FORM.HEADER_CONTENT')"
    />
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.apiToken.$error }">
          {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.WB.FORM.API_TOKEN_LABEL') }}
          <input
            v-model="apiToken"
            type="password"
            :placeholder="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.WB.FORM.API_TOKEN_PLACEHOLDER')"
            @blur="v$.apiToken.$touch"
          />
          <span class="message" v-if="v$.apiToken.$error">
            {{ $t('INBOX_MGMT.ADD.AUTH.COMMON.REQUIRED_FIELD') }}
          </span>
          <p class="help-text">
            {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.WB.FORM.API_TOKEN_HELP') }}
          </p>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <label>
          {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.WB.FORM.STORE_NAME_LABEL') }}
          <input
            v-model="storeName"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.WB.FORM.STORE_NAME_PLACEHOLDER')"
          />
          <p class="help-text">
            {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.WB.FORM.STORE_NAME_HELP') }}
          </p>
        </label>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.WB.FORM.CREATE_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
